import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import logoImg from "$/logoOrange.svg";
import {
  useBusinessAuthUserInfo,
  getBusinessAuthHasCompany,
} from "~/services/business/auth";
import { useBusinessWithdrawal } from "~/services/auth";
import { Dialog } from "@/Dialog";
// import { useAppExit } from "^/common/useAppExit";
// import { AppExitDialog } from "@/AppExitDialog";
// import { signOutForOAuth } from "#/auth/signIn";
// import { SignType } from "#/unique/domain";
// import { useStorage } from "^/common/useStorage";

export const Route = createFileRoute("/business/layout/teacher")({
  component: RouteComponent,
});

function RouteComponent() {
  const { history } = useRouter();
  const { data: businessUserInfo, refetch: refetchBusinessUserInfo } =
    useBusinessAuthUserInfo();
  // const [sns] = useStorage<SignType>("local-sign-sns-type");
  const [isWithdrawalConfirmVisible, setIsWithdrawalConfirmVisible] =
    useState(false);
  const [isWithdrawalCompleteVisible, setIsWithdrawalCompleteVisible] =
    useState(false);
  const [isReloginRequiredVisible, setIsReloginRequiredVisible] =
    useState(false);

  const { mutate: withdrawal } = useBusinessWithdrawal();

  // const { showExitDialog, hideExitConfirmation, confirmAppExit } = useAppExit();

  console.log(businessUserInfo);
  const handleWithdrawalConfirmOpen = () => {
    setIsWithdrawalConfirmVisible(true);
  };

  const handleWithdrawalConfirmClose = () => {
    setIsWithdrawalConfirmVisible(false);
  };

  const handleWithdrawalCompleteClose = () => {
    setIsWithdrawalCompleteVisible(false);
    handleLogout();
  };

  const handleWithdrawalConfirm = () => {
    setIsWithdrawalConfirmVisible(false);

    withdrawal(undefined, {
      onSuccess: (response) => {
        console.log("회원탈퇴 성공:", response);
        setIsWithdrawalCompleteVisible(true);
        handleLogout();
      },
      onError: (error) => {
        console.error("회원탈퇴 실패:", error);
        // 에러 처리 (필요시 토스트 메시지 등)
      },
    });
  };

  // 페이지 진입 시 사용자 정보 갱신
  useEffect(() => {
    refetchBusinessUserInfo();
  }, [refetchBusinessUserInfo]);

    // 할당된 업체가 있으면 메인 페이지로 리다이렉트
  // useEffect(() => {
  //   if (
  //     businessUserInfo &&
  //     businessUserInfo.isTeacher &&
  //     businessUserInfo.assignedCompany
  //   ) {
  //     history.push("/business/layout/to-school");
  //   }
  // }, [businessUserInfo, history]);
  
  // 상태 새로고침 핸들러
  const handleRefresh = async () => {
    try {
      // /business/auth/hasCompany API 호출
      const updatedUserInfo = await getBusinessAuthHasCompany();

      // 조건 확인: businessUserInfo, isTeacher, assignedCompany가 모두 있으면 재로그인 필요
      if (
        updatedUserInfo &&
        updatedUserInfo.isTeacher &&
        updatedUserInfo.assignedCompany
      ) {
        setIsReloginRequiredVisible(true);
      }
    } catch (error) {
      console.error("사용자 정보 갱신 실패:", error);
    }
  };

  // 재로그인 필요 모달 확인 핸들러
  const handleReloginConfirm = async () => {
    // 모달 닫기
    setIsReloginRequiredVisible(false);
    
    // Dialog가 완전히 닫힌 후 로그아웃 처리
    setTimeout(async () => {
      // 로그아웃 처리
      const userAgent = navigator.userAgent;
      if (/MT_A/i.test(userAgent) || /MT_I/i.test(userAgent)) {
        let snsType = "";
        if (businessUserInfo?.cdSnsType === "SNS_TYPE_KAKAO") {
          snsType = "kakao";
        } else if (businessUserInfo?.cdSnsType === "SNS_TYPE_GOOGLE") {
          snsType = "google";
        } else if (businessUserInfo?.cdSnsType === "SNS_TYPE_APPLE") {
          snsType = "apple";
        } else if (businessUserInfo?.cdSnsType === "SNS_TYPE_NAVER") {
          snsType = "naver";
        }
        if (/MT_A/i.test(userAgent)) {
          window.mung.appLoginOut(snsType);
        }
        if (/MT_I/i.test(userAgent)) {
          const array = ["appLoginOut"];
          array.push(snsType);
          window.webkit?.messageHandlers?.mung?.postMessage(array);
        }
      }

      // 로컬스토리지에서 토큰들 삭제
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("local-sns-id");
      localStorage.removeItem("local-sign-sns-type");
      localStorage.removeItem("session-fcm");

      // 세션스토리지에서도 SNS 정보 삭제 (자동로그인 방지)
      sessionStorage.removeItem("session-sign-sns-type");

      // 강제로 페이지 이동 (history.push가 작동하지 않을 경우 대비)
      window.location.href = "/";
    }, 300); // Dialog 애니메이션 완료 대기
  };

  const handleLogout = async () => {
    const userAgent = navigator.userAgent;
    if (/MT_A/i.test(userAgent) || /MT_I/i.test(userAgent)) {
      let snsType = "";
      if (businessUserInfo?.cdSnsType === "SNS_TYPE_KAKAO") {
        snsType = "kakao";
      } else if (businessUserInfo?.cdSnsType === "SNS_TYPE_GOOGLE") {
        snsType = "google";
      } else if (businessUserInfo?.cdSnsType === "SNS_TYPE_APPLE") {
        snsType = "apple";
      } else if (businessUserInfo?.cdSnsType === "SNS_TYPE_NAVER") {
        snsType = "naver";
      }
      if (/MT_A/i.test(userAgent)) {
        window.mung.appLoginOut(snsType);
      }
      if (/MT_I/i.test(userAgent)) {
        const array = ["appLoginOut"];
        array.push(snsType);
        window.webkit?.messageHandlers?.mung?.postMessage(array);
      }
    }

    // 로컬스토리지에서 토큰들 삭제
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("local-sns-id");
    localStorage.removeItem("local-sign-sns-type");
    localStorage.removeItem("session-fcm");

    // 세션스토리지에서도 SNS 정보 삭제 (자동로그인 방지)
    sessionStorage.removeItem("session-sign-sns-type");

    // 메인 페이지로 이동
    history.push("/");
  };

  return (
    <div className="flex-auto flex flex-col justify-center items-center px-4 bg-gray-50">
      {/* 상단 아이콘 영역 */}
      <div className="w-[56px] h-[56px] flex items-center justify-center mb-6">
        <img src={logoImg} alt="logo" className="w-[56px] h-[56px]" />
      </div>

      {/* 메인 타이틀 */}
      <h1 className="mb-2 text-xl font-bold text-center text-black">
        선생님이 등록된 사업자가 없어요
      </h1>

      {/* 서브타이틀 */}
      <p className="text-sm text-[#666666] text-center mb-2 px-4">
        멍투데이 for 비즈니스는
      </p>
      <p className="text-sm text-[#666666] text-center mb-10 px-4">
        등록된 사업자 정보가 있어야 활성화 되요
      </p>

      {/* 하단 정보 박스 */}
      <div className="p-6 w-full max-w-sm bg-white rounded-lg">
        <h2 className="mb-2 text-base font-bold text-center text-black">
          근무중인 사업장이 있다면?
        </h2>
        <p className="text-sm text-center text-black">
          사업장 원장님에게 훈련사 등록을 요청해주세요
        </p>
      </div>
      {/* 이메일 주소 */}
      <p className="mt-6 text-sm text-center text-black">
        {businessUserInfo?.email}
      </p>
      {/* 새로고침 버튼 */}
      <button
        onClick={handleRefresh}
        className="px-6 py-2 mt-6 text-sm font-medium text-white bg-orange-500 rounded-lg"
      >
        상태 새로고침
      </button>

      {/* 로그아웃과 회원 탈퇴 버튼 */}
      <div className="flex justify-between px-4 pb-4 mt-10 w-full max-w-sm">
        <button
          className="text-sm text-gray-400 text-[#666666]"
          onClick={() => handleLogout()}
        >
          로그아웃
        </button>
        <button
          className="text-sm text-gray-400 text-[#666666]"
          onClick={handleWithdrawalConfirmOpen}
        >
          회원탈퇴
        </button>
      </div>

      {/* 회원탈퇴 확인 모달 */}
      <Dialog
        visible={isWithdrawalConfirmVisible}
        onClose={handleWithdrawalConfirmClose}
        persist={false}
      >
        <div className="flex flex-col gap-1">
          <div className="flex flex-col mb-2">
            <div className="text-lg font-semibold text-center">회원 탈퇴</div>
          </div>
          <div className="flex flex-col mb-2">
            <div className="text-sm text-center text-[#666666]">
              회원 탈퇴 시 모든 개인정보 및 사업자 정보를
            </div>
            <div className="text-sm text-center text-[#666666]">
              더이상 확인하실 수 없으며, 정산정보가 삭제됩니다.
            </div>
            <div className="text-sm text-center text-[#666666] mt-2">
              탈퇴 후에는 삭제된 정보를 복구할 수 없습니다.
            </div>
          </div>
          <div className="flex gap-3 mt-2">
            <button
              className="flex-1 py-2 font-semibold text-gray-600 border border-[#E5E5E5] rounded-full"
              onClick={handleWithdrawalConfirmClose}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={handleWithdrawalConfirm}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 회원탈퇴 완료 모달 */}
      <Dialog
        visible={isWithdrawalCompleteVisible}
        onClose={handleWithdrawalCompleteClose}
        persist={false}
      >
        <div className="flex flex-col gap-1">
          <div className="flex flex-col mb-2">
            <div className="text-lg font-semibold text-center">회원 탈퇴</div>
          </div>
          <div className="flex flex-col mb-2">
            <div className="text-sm text-center text-[#666666]">
              회원 탈퇴가 완료되었습니다.
            </div>
          </div>
          <div className="flex gap-3 mt-2">
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={handleWithdrawalCompleteClose}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 재로그인 필요 모달 */}
      <Dialog
        visible={isReloginRequiredVisible}
        onClose={() => setIsReloginRequiredVisible(false)}
        persist={false}
      >
        <div className="flex flex-col gap-1">
          <div className="flex flex-col mb-2">
            <div className="text-lg font-semibold text-center">
              재로그인이 필요합니다
            </div>
          </div>
          <div className="flex flex-col mb-2">
            <div className="text-sm text-center text-[#666666]">
              할당된 업체 정보가 변경되었습니다.
            </div>
            <div className="text-sm text-center text-[#666666]">
              다시 로그인해주세요.
            </div>
          </div>
          <div className="flex gap-3 mt-2">
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={handleReloginConfirm}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* <AppExitDialog
        visible={showExitDialog}
        onConfirm={confirmAppExit}
        onCancel={hideExitConfirmation}
      /> */}
    </div>
  );
}
